import React from 'react';
import { func, array } from 'prop-types';

const swapElement = (list,insertVal,valOfInsertedPos) => {
	const insertPos = list.indexOf(valOfInsertedPos);
	let target = list.filter(val=>{
		return val !== insertVal;
	});
	target.splice(insertPos,0,insertVal);
	return target;
};

export default class DragAndDropEventHandler extends React.Component {
		static propTypes = {
			values : array,
			onSort : func,
			render : func,
		}

		constructor(props){
			super(props);
			const {values} = props;
			const indices = [...Array(values.length)].map((_,i)=>i);
			this.state = {
				indices : indices,
				backup : indices.slice(),
				dragging : -1,
				overred : -1
			};
		}

		render(){

			const {onSort,values} = this.props;

			const onDragStart = idx => e =>{
				e.dataTransfer.effectAllowed = 'move';
				this.target = e.currentTarget;

				this.setState({dragging : idx});
			};

			const onDragOver = idx => e =>{
				if (e.preventDefault) {
					e.preventDefault(); // Necessary. Allows us to drop.
				}
                
				e.dataTransfer.dropEffect = 'move';
                
				const overred = idx===this.state.dragging;

				if(!overred){
                    
					const nextIndices = swapElement(this.state.indices,idx,this.state.dragging);
                    
					this.setState({
						indices:nextIndices,
					});
				}
			};
			const onDrop = idx => e =>{

				if (e.stopPropagation) {
					e.stopPropagation(); // stops the browser from redirecting.
				}
                
				const nextIndices = swapElement(this.state.indices,idx,this.state.dragging);
                
				onSort(nextIndices);
			};

			const onDragEnd = ()=>{
				this.setState({
					dragging : -1,
					overred:-1,
					indices : this.state.backup.slice(),
				});
			};
			return this.state.indices.map(i => {
				return this.props.render({
					value : values[i],
					index : i,
					isDragging : i === this.state.dragging,
					onDragStart : onDragStart(i),
					onDragOver : onDragOver(i),
					onDrop : onDrop(i),
					onDragEnd : onDragEnd,
					draggable : true,
				});
			});

		}
}
